module.exports = __webpack_public_path__ + "static/media/menu.c9940670.svg";